module.exports = __webpack_public_path__ + "static/img/catalog_settings_bind.5f04d2a4.png";